import { NgModule } from '@angular/core';
import { DxLoadPanelModule } from 'devextreme-angular';
import { SharedModule } from '../../../shared/shared.module';
import { ButtonWithIndicatorModule } from '../button-with-indicator/button-with-indicator.module';
import { ModalWindowComponent } from './modal-window.component';
import { ModalWindowService } from './modal-window.service';
import { ModelWindowToolbarActionPipe } from './model-window-toolbar-action.pipe';

@NgModule({
  imports: [SharedModule, ButtonWithIndicatorModule, DxLoadPanelModule],
  declarations: [ModalWindowComponent, ModelWindowToolbarActionPipe],
  exports: [ModalWindowComponent, ModelWindowToolbarActionPipe],
  providers: [ModalWindowService],
})
export class ModalWindowModule {}
